import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

export function isArrayWithLength(arr) {
  return Array.isArray(arr) && arr.length;
}

//Will get allowed routes based from login role
// export function getAllowedRoutes(routes) {
//   const userRole = localStorage.getItem("userRole");
//   return routes.filter(({ permission }) => {
//     if (!permission) {
//       return true;
//     } else if (!isArrayWithLength(permission)) {
//       return true;
//     } else {
//       return intersection(permission, [parseInt(userRole)]).length;
//     }
//   });
// }

//Map allowed routes from getAllowedRoutes function
export function PrivateRoutes({ allowedRoutes }) {
  const isAuth = localStorage.getItem("token");

  return (
    <Switch>
      {allowedRoutes.map((route) => {
        const {
          path,
          component: Component,
          children,
          permission,
          ...rest
        } = route;

        return isAuth ? (
          <Route {...rest} key={path} path={path}>
            <Component children={children} />
          </Route>
        ) : (
          <Redirect to="/login" />
        );
      })}
    </Switch>
  );
}
